/* 
  snap 素材上传
*/
import { isArray } from 'lodash';
import { postSaveAdFile } from '../../serve/material';
import { saveOptLogSnapFunc } from '../../serve/snap';
import useUpLoadFileMixin from '../../utils/useUpLoadFile.js';
export default {
  mixins: [useUpLoadFileMixin],
  data() {
    return {
      // fileList: [],
      seat: 'default',
    };
  },
  computed: {
    snapEditLandingPageInfo() {
      return this.$store.state.initData.snapEditLandingPageInfo || null;
    },
    userInfo() {
      return this.$store.state.user.userInfo.data;
    },
    saveAdFileParam() {
      return {
        initiatorUid: this.userInfo.id,
        uid: this.userInfo.id,
        orgCode: this.userInfo.orgCode,
        saleId: this.data?.promotionInfo?.sale?.id || this.snapEditLandingPageInfo?.saleId || 0,
        langId: this.data?.promotionInfo?.sale?.langId || this.snapEditLandingPageInfo?.langId || 0,
        proId: this.data?.promotionInfo?.sale?.productId || this.snapEditLandingPageInfo?.productId || 0,
      };
    },
  },
methods: {
    async httpRequest(options) {
      console.log('uploadMaterial httpRequest', options);
      const file = options;
      try {
        const res = await this.useUpLoadFile(file, {
          elOptions: options,
        });
        res.sourceType = 'SELF_MATERIAL'; //资源来源：SELF_MATERIAL 自建素材
        const saveRes = await this.saveFileResources(res);
        return saveRes;
      } catch (error) {
        console.log('uploadMaterial httpRequest error', error);
        return { status: 'error', name: file.name };
      }
    },

    getMaterialType(fileExt) {
      const isImage = ['.jpg', '.jpeg', '.png', '.gif', '.webp'].includes(fileExt);
      const isVideo = ['.mp4', '.mov', '.wmv', '.avi', '.mkv', '.flv', '.m4v', '.3gp', '.webm'].includes(fileExt);
      return isImage ? 'IMAGE' : isVideo ? 'VIDEO' : 'other';
    },

    async saveFileResources(fileInfo) {
      console.log(fileInfo, 'fileInfo');

      const { url, md5: md5_code, size: file_size, ext, name: file_name, high, width } = fileInfo;
      let fileData = { url, md5_code, file_size, ext, file_name, play_time: '' };
      if (width && high) {
        fileData.width = width;
        fileData.high = high;
      }
      //固定参数 source 来源来源: 1:上传 2:广告 3:工作流 4:三方工作流 5:混剪 6:广告回传 isAgent 是否需要代理下载: 0:否 1:是
      const defaultParams = { source: 2, isAgent: 0 };
      const params = { ...this.saveAdFileParam, ...defaultParams, fileData: [fileData] };
      try {
        const res = await postSaveAdFile(params);
        if (res?.code !== 0) {
          throw new Error(res);
        }
        /** platform：平台；adAccountId： 账户；fileId：素材id；mediaType：素材类型；sourceType：素材来源（UPLOAD("上传"),SELF_LIB("个人素材库")） */
        let mediaOptLogId = null;
        if (localStorage.getItem('multiPlatform_platform_select') === 'snapchat') {
          const params = {
            platform: 'snapchat', //平台
            adAccountId: localStorage.getItem('snap-accountId'),
            fileId: isArray(res.data) ? res.data[0] : res.data, //素材id
            mediaType: this.getMaterialType(ext),
            sourceType: 'UPLOAD',
          };
          const result = await saveOptLogSnapFunc(params);
          console.log('cgl--saveOptLogSnapFunc', result);
          mediaOptLogId = result?.data?.id || null;
        }
        return { ...fileInfo, id: res.data[0], mediaOptLogId };
      } catch (error) {
        console.log('uploadMaterial saveFileResources error', error);
        return { status: 'error', name: file_name };
      }
    },
  },
};
